export default {
  app: {
    dashboard: 'Synthèse',
    scenes: 'Scènes',
    title: 'Diakse',
    products: 'Produits',
    time: 'Comportements',
    footer: '© Diakse 2018',
    survey: 'Questionnaires'
  },
  dashboard: {
    tooltips: {
      new: 'Nouveau',
      export: 'Exporter',
      edittab: 'Modifer Onglet',
      deletetab: 'Suprimmer Onglet',
      menuButton: 'Plus',
      drag: 'Déplacer',
      informations: 'Informations',
      close: 'Fermer'
    },
    dialogs: {
      edit: {
        title: 'Changer titre',
        text: 'Titre',
        description: 'Choisissez un nouveau titre pour l\'onglet.',
        cancel: 'Annuler',
        save: 'Sauvegarder'
      },
      delete: {
        title: 'Êtes vous sûr?',
        description: 'Vous êtes sur le point de suprimmer cet onglet. Cette action est irréversible.',
        cancel: 'Non, annuler',
        save: 'Oui'
      },
      editgraph: {
        title: 'Changer graphique',
        description: 'Choisissez le nouveau graphique.',
        cancel: 'Annuler',
        save: 'Changer'
      },
      addgraph: {
        title: 'Ajouter graphique',
        description: 'Choisissez le graphique à ajouter.',
        cancel: 'Annuler',
        save: 'Ajouter'
      }
    },
    menu: {
      create: {
        addtab: 'Ajouter Onglet',
        addgraph: 'Ajouter Graphique'
      },
      graph: {
        openButton: 'Ouvrir',
        changeButton: 'Changer'
      },
      export:{
        exportComport: 'Enregistrements',
        exportSurvey: 'Sondages',

      }
    },
    newTabTitle: 'Nouveau tableau'
  },
  charts: {
    clickedItems: {
      legend: 'Nombre de clics sur chaque bouton (WIP)',
      xaxis: 'Bouton',
      yaxis: 'Nombre de clics'
    },
    timePerScene: {
      legend: 'Temps moyen passé sur chaque scène par visiteur',
      xaxis: 'Scène',
      yaxis: 'Temps moyen (en minutes)'
    },
    timePerEnv: {
      legend: 'Temps cumulé passé sur environnment',
      xaxis: 'Environnements',
      yaxis: 'Temps'
    },
    allClickedItems: {
      legend: "Nombre d'items cliqués",
      xaxis: 'Item',
      yaxis: 'Nombre de clics'
    },
    scenesPerSession: {
      legend: "Nombre de sessions où il y a eu x scènes visitées",
      xaxis: 'Nombre de scènes visitées',
      yaxis: 'Nombre de sessions'
    },
    clicksPerSession: {
      legend: "Nombre de sessions où il y a eu x items cliqués",
      xaxis: 'Nombre de clics',
      yaxis: 'Nombre de sessions'
    },
    visitorsPerHour: {
      legend: "Nombre de visiteurs par heure",
      xaxis: 'Heure',
      yaxis: 'Nombre de visiteurs'
    },
    numberOfScenesVisited: {
      legend: 'Nombre de scènes visitées',
      xaxis: 'Scène',
      yaxis: 'Nombre de scènes'
    },
    numberOfPagesSeen: {
      legend: 'Nombre de pages vues par semaine',
      xaxis: 'Semaine',
      yaxis: 'Nombre de pages vues'
    },
    numberOfVisitors: {
      legend: 'Nombre de visiteurs par semaine',
      xaxis: 'Semaine',
      yaxis: 'Nombre de visiteurs'
    },
    numberOfProductsAddedToCart: {
      legend: 'Nombre de produits ajoutés au panier par semaine',
      xaxis: 'Semaine',
      yaxis: 'Nombre de produits'
    },
    numberOfProductsConsulted: {
      legend: 'Nombre de produits consultés par semaine',
      xaxis: 'Semaine',
      yaxis: 'Nombre de produits'
    },
    numberOfVisits: {
      legend: 'Nombre de visites par semaine',
      xaxis: 'Semaine',
      yaxis: 'Nombre de visites'
    },
    ratingsPerSession: {
      legend: 'Apercu des ratings',
      xaxis: 'Periode',
      yaxis: 'Apercu des ratings'
    },
    meanRatingsPerPeriod: {
      legend: 'Notes moyennes hebdomadaire des ratings',
      xaxis: 'Periode',
      yaxis: 'Notes moyennes des ratings'
    },
    numberOfVisitsFromSeat: {
      legend: "Nombre de visites issues d'un siège VR par semaine",
      xaxis: 'Semaine',
      yaxis: 'Nombre de visites'
    },
    viewedProducts: {
      legend: 'Nombre de produits ajouté au panier',
      xaxis: 'Produits',
      yaxis: 'Produit Ajouté'

    },

    nbClicks: {
      legend: 'Nombre de clics sur chaque bouton',
      xaxis: 'Bouton',
      yaxis: 'Nombre de clics'
    },
    nbProductsAddedToCart: {
      legend: 'Nombre de produits ajoutés au panier ',
      xaxis: 'Produits',
      yaxis: 'Ajouts au panier'
    },
    visitsPerHour: {
      legend: 'Répartition des visites dans la journée',
      xaxis: 'Heure de la journée',
      yaxis: 'Nombre de visites'
    },
    clickedItemsPerType: {
      legend: 'Produits cliqués pour chaque catégorie sélectionnée (WIP)',
      xaxis: 'Produits cliqués',
      yaxis: 'Nombre de clics'
    },
    maxSessionLength: {
      legend: 'Temps passé par session',
      xaxis: 'Sessions',
      yaxis: 'Temps passé'
    },
    meanSessionLength: {
      legend: 'Durée moyenne des sessions par semaine',
      xaxis: 'Semaine',
      yaxis: 'Durée moyenne (en minutes)'
    },
    meanSessionsPerWeek: {
      legend: 'Nombre de sessions par semaine',
      xaxis: 'Semaines',
      yaxis: 'Nombre de sessions'
    },
    scenesViewedPerSession: {
      legend: 'Nombre de scènes parcourues par session',
      xaxis: 'Nombre de scènes',
      yaxis: 'Nombre de sessions'
    },
    surveyOverview: {
      legend: 'Taux de reponses',
      xaxis: 'Reponses',
      yaxis: 'Nombre'
    },
    surveyCompletionRatio: {
      legend: 'Taux de remplissage Questionnaire',
      xaxis: 'Taux (%)',
      yaxis: 'Nombre de personnes'
    },
    heatmap: {
      legend: 'Carte de chaleur (WIP)'
    },
    itemsInScene: {
      legend: 'Items cliqués dans une scène donnée',
      xaxis: 'Item',
      yaxis: 'Nombre de clics'
    },
    surveyAnswers: {
      legend: 'Réponses aux questions'
    },
    timeRange: 'Plage de temps',
    globalAverage: 'Moyenne générale',
    totalValue: 'Total',
    weightedAverage: 'Moyenne pondérée',
    median: 'Médiane',
    totalusers: 'Nombre total des utilisateurs',
    totalcount: 'Total',
    clicks: 'clics',
    timeformat: '24',
    All: 'Tout',
    Direct: 'Direct',
    Carousels: 'Carousels'
  },
  datePicker: {
    pick: 'Choisissez une plage de temps',
    from: 'Du:',
    to: 'Au:',
    preset: 'Préfait',
    today: 'Aujourd\'hui',
    lastweek: 'La semaine dernière',
    last30days: '30 derniers jours',
    lastyear: 'Année dernière',
    startDate: 'Date de départ ',
    endDate: 'Date de fin ',
    dateFormat: 'DD/MM/YYYY',
    locale: 'fr',
    alltime: 'Le mois dernier',
    firstdayofweek: '1'
  },
  info: {
    dashboard: {
      title: 'Premiers pas - Tableau de Bord',
      content: {
        '1': `Bienvenue sur votre Application de pistage de données.`,
        '2': `Ici, vous pouvez accéder à toutes les données
          de vos boutiques. Vous avez à votre disposition plusieurs Tableaux de Bords proposés par Diakse
          pour vous guider au mieux vers votre objectif. Vous pouvez créer votre Tableau personnalisé ou ajouter un graphique sur le tableau actuel
          en cliquant sur l'icone + en haut à gauche.`,
        '3': `
          Vous pouvez recadrer, déplacer, fermer ou ajouter un nouveau graphique. Le bouton "Changer" permet de changer de graphique.
          Selectionnez la plage de temps de votre choix en cliquant sur le bouton dédié en-dessous des graphiques: par défaut, la plage de temps est le mois dernier. 
          Vous pouvez également choisir de tenir compte que des statistiques issues des carousels ou directement de votre site internet.`
      }
    },
    scenes: {
      title: 'Premiers pas - Scènes',
      content: {
        '1': `Vous êtes ici dans l'onglet Détails des Scènes, où vous pouvez voir les graphiques les plus
        détaillés sur les Scènes.`,
        '2': `Pour changer de graphique, cliquez sur le nom du graphique voulu sur la barre noire en haut au centre.
         Certains Graphiques vous demanderons de choisir une scènes en particulier,
          une barre apparaîtra alors a droite, où vous pourrez selectionner la scène de votre choix.`
      }
    },
    products: {
      title: 'Premiers pas - Produits',
      content: {
        '1': `Vous êtes ici dans l'onglet Détails des Produits, où vous pouvez voir les graphiques les plus
        détaillés sur les Produits.`,
        '2': `Pour changer de graphique, cliquez sur le nom du graphique voulu sur la barre
        noire en haut au centre. Certains Graphiques vous demanderons de choisir un produit en particulier, 
        une barre apparaîtra alors a droite, où vous pourrez selectionner le produit de votre choix.`
      }
    },
    time: {
      title: 'Premiers pas - Tableau de Bord',
      content: {
        '1': `Vous êtes ici dans l'onglet Comportements, où vous avez accès à des informations sur le
        comportement de vos clients comme les notations, leur trajet, s'ils utilisent leur casque, et bien plus encore.`,
        '2': `Pour changer de graphique, cliquez sur le nom du graphique voulu sur la barre
        noire en haut au centre. Certains Graphiques vous demanderons de choisir une heure en particulier, 
        une barre apparaîtra alors a droite, où vous pourrez selectionner l'heure de votre choix.`
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langFr.js